<div class="table-actions">
  <div class="table-actions-pagination">
    <div class="table-actions-pagination-buttons">
      <button
        [disabled]="!pagination.next || pagination.next === pagination.last + 1"
        class="table-actions-pagination-buttons-button"
        (click)="fetch('next')"
      >
        <img [src]="paginateIcons.next" />
      </button>
      <button
        [disabled]="!pagination.prev || pagination.prev === 0"
        class="table-actions-pagination-buttons-button"
        (click)="fetch('previous')"
      >
        <img [src]="paginateIcons.prev" />
      </button>
    </div>
    <div class="table-actions-pagination-meta">
      <div class="table-actions-pagination-meta-dropdown">
        <img class="table-actions-pagination-meta-dropdown-icon" [src]="paginateIcons.dropdown" />
        <div class="table-actions-pagination-meta-dropdown-count">
          <button
            class="table-actions-pagination-meta-dropdown-count-button"
            (click)="fetch(null, 20)"
            [class.--active]="pagination.pageSize === 20"
          >
            20
          </button>
          <button
            class="table-actions-pagination-meta-dropdown-count-button"
            (click)="fetch(null, 50)"
            [class.--active]="pagination.pageSize === 50"
          >
            50
          </button>
          <button
            class="table-actions-pagination-meta-dropdown-count-button"
            (click)="fetch(null, 100)"
            [class.--active]="pagination.pageSize === 100"
          >
            100
          </button>
        </div>
      </div>
      <span class="table-actions-pagination-meta-data">
        {{ pagination.currentPage }} / {{ pagination.last }} , {{ pagination.totalItems }}
      </span>
    </div>
  </div>
</div>